import React from "react";

function Input(props) {
  const { textColor, bgColor, ...rest } = props;

  let tColor = "text-gray-700";
  if (textColor) tColor = textColor; // overwrite

  let bColor = "bg-white";
  if (bgColor) bColor = bgColor; // overwrite

  return (
    <input
      className={`shadow-inner h-18 border rounded w-full p-2 focus:shadow-md focus:outline-none ${tColor} ${bColor}`}
      {...rest}
    />
  );
}

export default Input;
